import React, {useEffect, useState} from 'react';
import {User} from "types/User";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import {useNotifications} from "context/NotificationContext";

type Props = {
    user: User | null
    show: boolean
    onDelete?: (user: User) => any
    onDeleteFail?: (user: User, error: unknown) => any
    onCancel?: () => any
}

function DeleteUser(props: Props) {
    const {user, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(user?.name || 'this user');
    const {mutateAsync: deleteUser} = useMutation(ngage.users.destroy)

    const {notify} = useNotifications()

    useEffect(() => {
        if(user) setName(user.name)
    }, [user]);

    async function handleDeleteUser() {
        if (user) {
            try {
                await deleteUser(user.id)
                await invalidate('users.audience');
                await invalidate('users.operator');

                notify("success", "User Deleted", `${user.name} has been permanently removed`)
                if (onDelete) onDelete(user)
            } catch (error) {
                notify("error", "User Not Deleted", `${user.name} could not be removed`)
                if (onDeleteFail) onDeleteFail(user, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title="Delete User"
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteUser}
            onCancel={handleCancel}
        />
    );
}

export default DeleteUser;